import { Tabs, TabsList, TabsTrigger } from '@bpinternal/ui-kit-next'
import { ChartDateShortcut } from '~/features/analytics'
import { useAgentAnalyticsContext } from './AgentAnalyticsContext'

type AnalyticsDateRangeSelectorProps = {
  className?: string
}

export const AnalyticsDateRangeSelector = ({ className }: AnalyticsDateRangeSelectorProps) => {
  const { dateShortcut, setDateShortcut } = useAgentAnalyticsContext()
  return (
    <Tabs
      defaultValue={dateShortcut}
      onValueChange={(value) => setDateShortcut(value as ChartDateShortcut)}
      className={className}
    >
      <TabsList className="flex w-full">
        <TabsTrigger value="lastDay" className="flex-1">
          Last 24 hours
        </TabsTrigger>
        <TabsTrigger value="lastWeek" className="flex-1">
          Last 7 days
        </TabsTrigger>
        <TabsTrigger value="lastMonth" className="flex-1">
          Last 30 days
        </TabsTrigger>
      </TabsList>
    </Tabs>
  )
}
